import styled, { css } from 'styled-components';
import { mediaQuery } from '~/src/styles/mixins';
import { MAX_1279, MAX_767 } from '~/src/styles/tokens/break-points';
import { rem } from '~/src/helpers/rem-converter.helper';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';
import { COLORS } from '~/src/styles/tokens/colors';
import { FONTS } from '~/src/styles/style-helpers/font-helper';

export const MainProductsContainer = styled.div<{ productsIsSelected: boolean; }>`
    gap: ${rem(24)};
    flex-direction: column;
    border-radius: ${BORDER_RADIUS.biggest20};
    border: ${rem(1)} solid ${p => p.productsIsSelected ? COLORS.backgroundOverlay : COLORS.textLightNegative};
    padding: ${rem(24)} ${rem(20)};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            padding: ${rem(20)} ${rem(16)};
        `,
    )};
`;

export const ProductsContainer = styled.div`
    width: 100%;
    gap: ${rem(120)};
    flex-wrap: nowrap;

    ${mediaQuery(
        { maxWidth: MAX_1279 },
        css`
            gap: ${rem(52)};
        `,
    )};

    ${mediaQuery(
        { maxWidth: MAX_767 },
        css`
            flex-direction: column;
            gap: ${rem(32)};
            width: 100%;
        `,
    )};
`;

export const CollapsedButtonContainer = styled.div<{ productsIsCollapsed: boolean; }>`
    width: 100%;
    justify-content: ${(p) => (p.productsIsCollapsed ? 'flex-start' : 'center')};
`;

export const CollapseButton = styled.button`
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
`;

export const CollapseButtonText = styled.span`
    ${FONTS.compact.medium.size17};
    color: ${COLORS.textLightPrimaryLink};
    margin-right: ${rem(8)};
`;

export const CollapseBtnArrowContainer = styled.div<{ rotate: number; }>`
    display: inline-block;
    width: fit-content;
    transform: ${p => `rotate(${p.rotate}deg)`};
`;

export const NotSelectedProductsError = styled.p`
    margin-top: ${rem(8)};
    ${FONTS.compact.regular.size12};
    line-height: ${rem(16)};
    color: ${COLORS.textLightNegative};
`;
